import { BookingInfo } from 'src/api/bookingsView';

import { SearchState } from './types';

export const emptyBookings: BookingInfo[] = [];

export const initialState: SearchState = {
  loading: false,
  rows: emptyBookings,
  now: null,
  token: null,
  hasMore: true,
  currentRequestId: undefined,
  employee: null,
  filtersAreOpened: false,
};
